import React from "react";
import { strings } from "../../../strings/strings";
import { Button } from "../../../components/ui";

const ConfirmUpdateModal = ({ open, onCancel, onConfirm, isPending }) => {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-black/40" onClick={onCancel} />

      <div className="relative w-full max-w-md rounded-2xl bg-white shadow-xl border">
        <div className="p-6">
          <h2 className="text-lg font-semibold text-gray-900">{strings.confirmUpdate}</h2>

          <p className="text-sm text-gray-600 mt-2">{strings.confirmUpdateMessage}</p>

          <div className="flex items-center justify-end gap-3 mt-6">
            <Button
              variant="outline"
              onClick={onCancel}
              disabled={isPending}
            >
              {strings.no}
            </Button>

            <Button
              variant="primary"
              onClick={onConfirm}
              isLoading={isPending}
              disabled={isPending}
            >
              {strings.yes}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfirmUpdateModal;
